export default {"src":"/_next/static/media/causeIcon.0465f3b1.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};